import {Injectable} from '@angular/core';
import {Router, CanActivate} from '@angular/router';
import {LocalStorageManager} from '../../manager/local-storage/local-storage.manager';
import { SessionEvent } from 'src/app/ui/shared/event-listeners/session/session.event';

@Injectable({
  providedIn: 'root',
})
export class SessionGuard implements CanActivate {
  constructor(private router: Router,
              private lsm: LocalStorageManager,
              private loginEvent: SessionEvent ) { }

  canActivate(): boolean {
    const customer = this.lsm.get('customer');
    if (customer?.isAnonymous || !customer?.customerId) {
      this.router.navigate(['/']);
      
      this.loginEvent.setLoginModalStatus({
        open: true
      });

      return false;
    }
    return true;
  }
}
